// extracted by mini-css-extract-plugin
export var pillWrapper = "_px-0";
export var showOverflow = "_px-1";